import { memo, useEffect } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import type { FXFormFieldConfig } from 'types/operations';

interface BaseFormFieldProps {
	fieldKey: string;
	fieldConfig: FXFormFieldConfig;
	disabled?: boolean;
}

export const HiddenFormField = memo(({ fieldKey, fieldConfig }: BaseFormFieldProps) => {
	const { control } = useFormContext();
	const { field } = useController({ name: fieldKey, control });

	useEffect(() => {
		if (field.value !== fieldConfig.value) {
			field.onChange(fieldConfig.value);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [fieldConfig.value]);

	return <input type="hidden" {...field} value={fieldConfig.value} />;
});

HiddenFormField.displayName = 'HiddenFormField';
